<script setup>
import { library } from '#helpers/icons.js'
import { computed } from 'vue'

const props = defineProps({
	name: { type: String, required: true },
	size: { type: Number, default: 24 },
	color: { type: String, default: 'currentColor' },
	strokeWidth: { type: Number, default: 2 },
	defaultClass: { type: String, default: '' },
})

const icon = computed(() => {
	if (library[props.name]) {
		return library[props.name]
	} else {
		/* oxlint-disable-next-line no-console */
		console.error(`Icon ${props.name} not found in library!`)
		return 'span'
	}
})
</script>

<template>
	<component
		:is="icon"
		:size="size"
		:color="color"
		:stroke-width="strokeWidth"
		:default-class="defaultClass"
	/>
</template>
